import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';
import { NOTIFICATION_MESSAGES_SLUG, PROVISIONING_LONG_OP_SLUG, SIGN_TEMPLATE_LONG_OP_SLUG, SIGN_TEMPLATE_SLUG, TENANT_CREDENTIAL_SLUG } from './shared/shared.module';
const title = environment ? environment.appTitle : 'Application Title';

const routes: Routes = [

  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...BaseRoutes.getEntityRoutes(
        title,
        SIGN_TEMPLATE_LONG_OP_SLUG,
        () => import('./sign-template-long-op/sign-template-long-op.module').then(m => m.SignTemplateLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        SIGN_TEMPLATE_SLUG,
        () => import('./sign-template/sign-template.module').then(m => m.SignTemplateModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        NOTIFICATION_MESSAGES_SLUG,
        () => import('./notification-messages/notification-messages.module').then(m => m.NotificationMessagesModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        PROVISIONING_LONG_OP_SLUG,
        () => import('./provisioning-long-op/provisioning-long-op.module').then(m => m.SignProcessLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        TENANT_CREDENTIAL_SLUG,
        () => import('./tenant-credential/tenant-credential.module').then(m => m.TenantCredentialModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ]
  ),
  // #endregion rotte con autenticazione

  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
  imports: [
    // TODO Tommy: si potrebbe creare una custom preloadin strategy per precaricare solo le rotte offline
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', paramsInheritanceStrategy: 'always', preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
